<template>

  <div class="encart" v-if="articles.length > 0">
    <div class="sort-bar" style="margin-bottom: 20px; display: flex; align-items: center; flex-wrap: wrap; gap: 8px;">
      <span style="font-weight: 600; color: #2b358d; font-size: 1rem;">Trier par :</span>
      
      <button type="button" class="sort-btn" @click="handleColumnSort('npce')">
        Code article
        <span v-if="sortColumn === 'npce'">
          <svg v-if="sortDirection === 'asc'" width="10" height="10" viewBox="0 0 10 10" style="margin-left:2px;"><path d="M5 2 L8 7 H2 Z" fill="#2b358d"/></svg>
          <svg v-else width="10" height="10" viewBox="0 0 10 10" style="margin-left:2px;"><path d="M5 8 L2 3 H8 Z" fill="#2b358d"/></svg>
        </span>
      </button>
      <button type="button" class="sort-btn" @click="handleColumnSort('desa1')">
        Désignation
        <span v-if="sortColumn === 'desa1'">
          <svg v-if="sortDirection === 'asc'" width="10" height="10" viewBox="0 0 10 10" style="margin-left:2px;"><path d="M5 2 L8 7 H2 Z" fill="#2b358d"/></svg>
          <svg v-else width="10" height="10" viewBox="0 0 10 10" style="margin-left:2px;"><path d="M5 8 L2 3 H8 Z" fill="#2b358d"/></svg>
        </span>
      </button>
      <button type="button" class="sort-btn" @click="handleColumnSort('qte')">
        Quantité
        <span v-if="sortColumn === 'qte'">
          <svg v-if="sortDirection === 'asc'" width="10" height="10" viewBox="0 0 10 10" style="margin-left:2px;"><path d="M5 2 L8 7 H2 Z" fill="#2b358d"/></svg>
          <svg v-else width="10" height="10" viewBox="0 0 10 10" style="margin-left:2px;"><path d="M5 8 L2 3 H8 Z" fill="#2b358d"/></svg>
        </span>
      </button>
      <button type="button" class="sort-btn" @click="handleColumnSort('besoin_couvert')">
        Besoin couvert
        <span v-if="sortColumn === 'besoin_couvert'">
          <svg v-if="sortDirection === 'asc'" width="10" height="10" viewBox="0 0 10 10" style="margin-left:2px;"><path d="M5 2 L8 7 H2 Z" fill="#2b358d"/></svg>
          <svg v-else width="10" height="10" viewBox="0 0 10 10" style="margin-left:2px;"><path d="M5 8 L2 3 H8 Z" fill="#2b358d"/></svg>
        </span>
      </button>
    </div>
    <div class="row">
      <RouterLink
        v-for="article in articles"
        :key="article.id"
        :to="getArticleLink(article)"
        class="col-xl-3 col-lg-4 col-md-6 col-12 article-card-link"
        style="display: flex;"
      >
        <div v-if="article.npce && article.npce.trim() !== ''" class="article-card" style="width: 100%;">
          <div class="card-header">
            <div class="code-article">
              <div class="top">
                <strong>Code article : </strong>{{ article.npce }}
              </div>
              <div class="bottom">
                <span>{{ article.nom_magasins }}</span>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="content">
              <div class="card-title">
                <div class="desa1">{{ article.desa1 }}</div>
                <div class="desa2">{{ article.desa2 }}</div>
                <div class="desa3">{{ article.desa3 }}</div>
              </div>
              <div class="card-infos">
                <span class="info-chip">Quantité : <strong>{{ article.qte }}</strong></span>
                <span class="info-chip">Magasin : <strong>{{ article.nom_magasins }}</strong></span>
                <!-- Ajoute ici d'autres infos si besoin -->
              </div>
            </div>
            <span class="besoin-couvert">
              <span v-if="(article.trueQte) - (calculateSum(article.npce)) > 0" class="greenBall"></span>
              <span v-else-if="(article.trueQte) - (calculateSum(article.npce)) == 0" class="orangeBall"></span>
              <span v-else class="redBall"></span>
            </span>
          </div>
        </div>
      </RouterLink>
    </div>
  </div>
</template>

<script>
import axios from '@/components/axiosConfig.js'

export default {
  data() {
    return {
      articles: [],
      quantiteAffaires: [],
      naf: '',
      codesArticles: [],
      articleDetails: {},
      sortColumn: '',
      sortDirection: 'asc',
      totalArticleCount: 0,
      greenBallCount: 0,
    }
  },
  created() {
    this.naf = this.$route.params.naf;
  },
  mounted() {
    axios.post('https://www.simef.fr/espace-client/api/getArticlesAffaire.php', {
      naf: this.naf,
      sortColumn: this.sortColumn,
      sortDirection: this.sortDirection,
    })
    .then(response => {
      this.articles = response.data;
      this.codesArticles = this.articles.map(article => article.npce);
      this.codesArticles.forEach(codeArticle => {
        axios.get(`https://www.simef.fr/espace-client/api/getAffairesQuantite.php?codeArticle=${codeArticle}`)
        .then(response => {
          const articleDetails = response.data;
          this.articleDetails[codeArticle] = articleDetails;
          this.calculateGreenBallCount();
        })
        .catch(error => {
          console.error(error);
        });
      });
    })
    .catch(error => {
      console.error(error);
    });
  },
  methods: {
    handleColumnSort(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
      axios.post('https://www.simef.fr/espace-client/api/getArticlesAffaire.php', {
        naf: this.naf,
        sortColumn: this.sortColumn,
        sortDirection: this.sortDirection,
      })
      .then(response => {
        this.articles = response.data;
        this.codesArticles = this.articles.map(article => article.npce);
        this.codesArticles.forEach(codeArticle => {
          axios.get(`https://www.simef.fr/espace-client/api/getAffairesQuantite.php?codeArticle=${codeArticle}`)
          .then(response => {
            const articleDetails = response.data;
            this.articleDetails[codeArticle] = articleDetails;
          })
          .catch(error => {
            console.error(error);
          });
        });
        this.calculateGreenBallAndTotalCount();
      })
      .catch(error => {
        console.error(error);
      });
    },
    calculateGreenBallAndTotalCount() {
      this.greenBallCount = 0;
      this.totalArticleCount = this.articles.length;
      for (const article of this.articles) {
        const detail = this.articleDetails[article.npce][0];
        if (detail) {
          if ((article.trueQte - this.calculateSum(article.npce)) > 0) {
            this.greenBallCount++;
          }
        }
      }
    },
    formatDate(date) {
      const year = date.substr(0, 4);
      const month = date.substr(4, 2);
      const day = date.substr(6, 2);
      const formattedDate = `${day}-${month}-${year}`;
      return formattedDate;
    },
    calculerSomme() {
      let somme = 0;
      for (let i = 0; i < this.quantiteAffaires.length; i++) {
        const qte = parseFloat(this.quantiteAffaires[i].qte, 10);
        somme += qte;
      }
      return somme;
    },
    getArticleLink(article) {
      var articleName =   article.desa1.replace(/\//g, "%2F").replace(/ /g, "");
      var articleName2 =  article.desa2.replace(/\//g, "%2F").replace(/ /g, "");
      var articleName3 =   article.desa3.replace(/\//g, "%2F").replace(/ /g, "");
      var coarti =  article.npce.replace(/\//g, "%2F").replace(/ /g, "");
      var magasin =  article.nom_magasins.replace(/\//g, "%2F").replace(/ /g, "");
      if (articleName === '') {
        articleName = 'empty';
      }
      if (articleName2 === '') {
        articleName2 = 'empty';
      }
      if (articleName3 === '') {
        articleName3 = 'empty';
      }
      if (coarti === '') {
        coarti = 'empty';
      }
      if (magasin === '') {
        magasin = 'empty';
      }
      let url = '/article/' + articleName + '/' + articleName2 + '/' + articleName3 + '/' + coarti + '/' + magasin;
      if (this.currentPage) {
        url += '/' + this.currentPage;
      } else {
        url += '/empty';
      }
      if (this.searchTerm) {
        url += '/' + this.searchTerm;
      } else {
        url += '/empty';
      }
      if (this.selectedFourn) {
        url += '/' + this.selectedFourn;
      } else {
        url += '/empty';
      }
      if (this.selectedMag) {
        url += '/' + this.selectedMag;
      } else {
        url += '/empty';
      }
      if (this.showOnlyAvailable) {
        url += '/' + this.showOnlyAvailable;
      } else {
        url += '/empty';
      }
      if (this.sortColumn) {
        url += '/' + this.sortColumn;
      } else {
        url += '/empty';
      }
      if (this.sortDirection) {
        url += '/' + this.sortDirection;
      } else {
        url += '/empty';
      }
      return url;
    },
    calculateSum(npce) {
      const details = this.articleDetails[npce];
      if (details) {
        return details.reduce((sum, detail) => sum + Number(detail.qte), 0);
      }
      return 0;
    },
  }
}
</script>

<style lang="scss">
  $primary: #2b358d;
  .reassort {
    background: rgb(255, 218, 218);
    padding: 5px 15px;
    display: flex;
    align-items: center;
    color: red;
    svg {
      margin-right: 5px;
    }
  }
  .text-dangerr {
    color: red!important;
  }
  .redBall {
    display: inline-block;
    background: red;
    height: 20px;
    width: 20px;
    border-radius: 50px;
  }
  .greenBall {
    display: inline-block;
    background: #00d712;
    height: 20px;
    width: 20px;
    border-radius: 50px;
  }
  .orangeBall {
    display: inline-block;
    background: #ffa600;
    height: 20px;
    width: 20px;
    border-radius: 50px;
  }
  h2 {
    text-align: left;
    margin-bottom: 15px!important;
  }
  h3 {
    font-size: 1.2rem!important;
    text-transform: none!important;
    font-weight: 600!important;
  }
  p {
    margin-bottom: 10px;
  }
  h4 {
    font-size: 1.2rem!important;
  }
  .infos {
    text-align: left;
  }
  .encart {
    text-align: left;
    border: 1px solid lightgrey;
    padding: 15px;
    background: #f2f2f2 !important;    
    margin-bottom: 25px;
  }
  .row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
  }
  .article-card-link {
    text-decoration: none;
    color: inherit;
  }
  .article-card {
    background: #fff;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    min-height: 180px;
    position: relative;
    transition: box-shadow 0.2s;
    width: 100%;
    border: 1px solid #cbcbcb;
    border-radius: 0px;
    &:hover {
      box-shadow: 0 4px 16px rgba(43,53,141,0.15);
    }
  }
  .card-header {
    display: flex!important;
    justify-content: space-between!important;
    align-items: center!important;
    margin-bottom: 0px!important;
    background: #2b358d!important;
    padding: 10px 20px!important;
    color: #fff!important;;
  div {
    font-weight: 700;
  }
  }
  .card-body {
    display: flex;
    height: 100%;
    .content {
      width: 92%;
      padding: 15px
    }
    .besoin-couvert {
      width: 8%;
      margin-left: 0px;
      span {
        height: 100%;
        width: 100% ;
        border-radius: 0px;
      }
    }
  }
  .card-title {
    margin-bottom: 10px;
    min-height: 70px;
    .desa1 {
      font-size: 1.1rem;
      font-weight: 700;
      color: #1d1d20;
    }
    .desa2, .desa3 {
      font-size: 0.9rem;
      color: #1d1d20;
      font-weight: 600;
    }
  }
  .card-infos {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 8px;
    flex-direction: column;
  }
  .info-chip {
    background: #f5f5f5;
    border-radius: 12px;
    padding: 4px 10px;
    font-size: 0.9rem;
    color: #1d1d20;
    display: flex;
    align-items: center;
    font-weight: 600;
    gap: 3px;
  }
  .sort-bar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 20px;
    span {
      font-weight: 600;
      color: #2b358d;
      font-size: 1rem;
    }
    .sort-btn {
      color: #fff;
      background: #2b358d;
      border: none;
      padding: 6px 14px;
      font-weight: 600;
      font-size: 0.98rem;
      display: flex;
      align-items: center;
      cursor: pointer;
      margin: 0px!important;
      svg {
        margin-left: 2px;
      }
      &:hover, &.active {
        background: #dbe9fa;
        color: #2b358d;
      }
    }
  }
</style>
